import React, { FC } from 'react';
import BreadCrumbs from '@/components/bread-crumbs';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.less';
import { Tooltip } from 'antd';
import crumbTypes from '@/constants/crumbs-type';
import { renderTypes } from '@/components/detail-header-info-wrapper/navBars/components/nav-render-module';

const { merchant_crumb_type } = crumbTypes;

interface navBarsPropsType {
  filterCrumbs?: (breadCrumbs: Array<any>) => Array<object>;
  renderCrumbs?: (breadCrumbs: Array<any>) => any;
}

const _filterCrumbs = (breadCrumbs: Array<any>) => {
  // 默认的筛选函数，根据主题活动下的活动类型筛选
  const _crumbArr: Array<any> = [];
  breadCrumbs.map((item) => {
    if (item.extInfo && merchant_crumb_type.indexOf(item.extInfo.type) > -1) _crumbArr.push(item);
  });
  return _crumbArr;
};

export const _renderCrumbs = (navBars: Array<any>) => {
  const _length = navBars.length;
  return _length
    ? navBars.map((item, index) => {
        const type = item?.extInfo?.type;
        // 通过设定的渲染模板renderTypes获取渲染元素
        const _item = { ...item, disableCrumb: item.extInfo?.disableCrumb, extInfo: renderTypes(type, item.extInfo) };
        const title = _item.extInfo?.title || _item.title; // 如果extInfo里面没有title，就用item原来的
        if (index === navBars.length - 1) {
          return (
            <div className="nav-title-wrapper last-nav-title-wrapper" key={index}>
              {!!_item.extInfo?.up_tag && <span className="nav-title-tag active">{_item.extInfo?.up_tag}</span>}
              <span className="navbar-item">
                <Tooltip title={title}>
                  <span className="navbar-item-text">{title}</span>
                </Tooltip>
                {!!_item.extInfo?.right_tag && <span className="nav-title-right">{_item.extInfo?.right_tag}</span>}
              </span>
            </div>
          );
        }

        return (
          <div className="nav-title-wrapper" key={index} style={{ maxWidth: `${Math.floor(100 / _length)}%` }}>
            {!!_item.extInfo?.up_tag && <span className="nav-title-tag ">{_item.extInfo?.up_tag}</span>}
            {_item.disableCrumb ? (
              <span className="navbar-item disable-crumb">
                <Tooltip title={title}>
                  <span className="navbar-item-text min-with">{title}</span>
                </Tooltip>
              </span>
            ) : (
              <span className="navbar-item">
                <Tooltip title={title}>
                  <Link to={_item.path}>
                    <span className="navbar-item-text min-with">{title}</span>
                  </Link>
                </Tooltip>
                <RightOutlined className="navbars-divider" />
              </span>
            )}
          </div>
        );
      })
    : null;
};

const NavBars: FC<navBarsPropsType> = ({ filterCrumbs = _filterCrumbs, renderCrumbs = _renderCrumbs }) => {
  let navBars: Array<any> = [];
  const renderCrumbsItems = (breadCrumbs: Array<any>) => {
    navBars = filterCrumbs(breadCrumbs);
    return renderCrumbs(navBars);
  };
  return (
    <div className="navbar-container">
      {/* @ts-ignore */}
      <BreadCrumbs renderCrumbs={renderCrumbsItems} />
    </div>
  );
};

export default NavBars;
